var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoLogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 151,
    height: 153,
    viewBox: "0 0 151 153",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "url(#paint0_linear_5070_176214)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_5070_176214)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5070_176214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 151,
    height: 150
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 150C116.921 150 150.5 116.421 150.5 75C150.5 33.5786 116.921 0 75.5 0C34.0786 0 0.5 33.5786 0.5 75C0.5 116.421 34.0786 150 75.5 150Z",
    fill: "#EFF4FF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5070_176214)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M118.5 43H32.5C29.7386 43 27.5 45.2386 27.5 48V153C27.5 155.761 29.7386 158 32.5 158H118.5C121.261 158 123.5 155.761 123.5 153V48C123.5 45.2386 121.261 43 118.5 43Z",
    fill: "white"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 53H40.5C38.8431 53 37.5 54.3431 37.5 56C37.5 57.6569 38.8431 59 40.5 59H66.5C68.1569 59 69.5 57.6569 69.5 56C69.5 54.3431 68.1569 53 66.5 53Z",
    fill: "#DAE5FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 95H40.5C38.8431 95 37.5 96.3431 37.5 98C37.5 99.6569 38.8431 101 40.5 101H66.5C68.1569 101 69.5 99.6569 69.5 98C69.5 96.3431 68.1569 95 66.5 95Z",
    fill: "#DAE5FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 68H42.5C40.2909 68 38.5 69.7909 38.5 72V82C38.5 84.2091 40.2909 86 42.5 86H108.5C110.709 86 112.5 84.2091 112.5 82V72C112.5 69.7909 110.709 68 108.5 68Z",
    stroke: "#467CEB",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.5 109H42.5C39.7386 109 37.5 111.239 37.5 114V122C37.5 124.761 39.7386 127 42.5 127H108.5C111.261 127 113.5 124.761 113.5 122V114C113.5 111.239 111.261 109 108.5 109Z",
    fill: "#DAE5FB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5 32C55.7091 32 57.5 30.2091 57.5 28C57.5 25.7909 55.7091 24 53.5 24C51.2909 24 49.5 25.7909 49.5 28C49.5 30.2091 51.2909 32 53.5 32Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.5 32C77.7091 32 79.5 30.2091 79.5 28C79.5 25.7909 77.7091 24 75.5 24C73.2909 24 71.5 25.7909 71.5 28C71.5 30.2091 73.2909 32 75.5 32Z",
    fill: "#6B96EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5 32C99.7091 32 101.5 30.2091 101.5 28C101.5 25.7909 99.7091 24 97.5 24C95.2909 24 93.5 25.7909 93.5 28C93.5 30.2091 95.2909 32 97.5 32Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 88C89.2614 88 91.5 85.7614 91.5 83C91.5 80.2386 89.2614 78 86.5 78C83.7386 78 81.5 80.2386 81.5 83C81.5 85.7614 83.7386 88 86.5 88Z",
    fill: "#DFEAFB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4071 104.37C89.6071 104.37 88.8601 104.37 88.1801 104.327C87.3425 104.271 86.5367 103.984 85.8515 103.499C85.1662 103.014 84.628 102.349 84.2961 101.578L80.0771 93.2404C79.7676 92.8801 79.6131 92.4121 79.6472 91.9384C79.6813 91.4647 79.9012 91.0236 80.2591 90.7114C80.5522 90.4757 80.918 90.3489 81.2941 90.3524C81.571 90.3604 81.8428 90.4284 82.0909 90.5517C82.339 90.675 82.5574 90.8506 82.7311 91.0664L84.6471 93.6814L84.6761 93.7154V83.7804C84.6761 83.2875 84.8719 82.8148 85.2204 82.4662C85.569 82.1177 86.0417 81.9219 86.5346 81.9219C87.0275 81.9219 87.5002 82.1177 87.8487 82.4662C88.1973 82.8148 88.3931 83.2875 88.3931 83.7804V90.2804C88.3715 90.0412 88.4 89.8001 88.4767 89.5726C88.5534 89.345 88.6767 89.1359 88.8387 88.9586C89.0007 88.7813 89.1979 88.6397 89.4176 88.5429C89.6374 88.446 89.8749 88.396 90.1151 88.396C90.3552 88.396 90.5928 88.446 90.8125 88.5429C91.0323 88.6397 91.2294 88.7813 91.3914 88.9586C91.5534 89.1359 91.6767 89.345 91.7535 89.5726C91.8302 89.8001 91.8587 90.0412 91.8371 90.2804V91.6354C91.8155 91.3962 91.844 91.1551 91.9207 90.9276C91.9974 90.7 92.1207 90.4909 92.2827 90.3136C92.4447 90.1363 92.6419 89.9947 92.8616 89.8979C93.0814 89.801 93.3189 89.751 93.5591 89.751C93.7992 89.751 94.0368 89.801 94.2565 89.8979C94.4763 89.9947 94.6734 90.1363 94.8354 90.3136C94.9974 90.4909 95.1207 90.7 95.1975 90.9276C95.2742 91.1551 95.3027 91.3962 95.2811 91.6354V92.6794C95.2595 92.4402 95.288 92.1991 95.3647 91.9716C95.4414 91.744 95.5647 91.5349 95.7267 91.3576C95.8887 91.1803 96.0859 91.0387 96.3056 90.9419C96.5254 90.845 96.7629 90.795 97.0031 90.795C97.2432 90.795 97.4808 90.845 97.7005 90.9419C97.9203 91.0387 98.1174 91.1803 98.2794 91.3576C98.4414 91.5349 98.5647 91.744 98.6415 91.9716C98.7182 92.1991 98.7467 92.4402 98.7251 92.6794V99.0164C98.6911 100.965 97.8101 104.251 94.7111 104.251C94.4861 104.261 92.5801 104.371 90.4111 104.371L90.4071 104.37Z",
    fill: "#6B96EF",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5070_176214",
    x: 21.5,
    y: 34,
    width: 108,
    height: 119,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5070_176214"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5070_176214",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5070_176214",
    x1: 75.5,
    y1: 0,
    x2: 75.5,
    y2: 150,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLogs);
export default __webpack_public_path__ + "static/media/noLogs.d2844d23e53c311baaba79557f5a8506.svg";
export { ForwardRef as ReactComponent };